import script from "./ClientCabinetItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientCabinetItem.vue?vue&type=script&setup=true&lang=js"

import "./ClientCabinetItem.vue?vue&type=style&index=0&id=1707043c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1707043c"]])

export default __exports__